import { ReactNode } from "react";
import { thStyle } from "../../../styles";
import { SortDir } from "../../../hooks/useAdminSort";

interface Props {
  label: ReactNode;
  sortKey: string;
  activeSortBy: string | null;
  sortDir: SortDir;
  onSort: (key: string) => void;
  align?: "left" | "center" | "right";
}

// A clickable <th> for admin list tables — a plain <button> inside the cell rather than an
// onClick on the <th> itself, so it stays keyboard-reachable and doesn't fail the axe checks
// several admin list pages already run. The dimmed ⇅ on inactive columns is a deliberate
// affordance: without it, nothing distinguishes a sortable header from a plain label.
export default function SortableTh({ label, sortKey, activeSortBy, sortDir, onSort, align = "left" }: Props) {
  const active = activeSortBy === sortKey;
  const justify = align === "right" ? "flex-end" : align === "center" ? "center" : "flex-start";

  return (
    <th
      style={{ ...thStyle, textAlign: align, padding: 0 }}
      aria-sort={active ? (sortDir === "asc" ? "ascending" : "descending") : "none"}
    >
      <button
        type="button"
        onClick={() => onSort(sortKey)}
        style={{
          display: "flex", alignItems: "center", gap: "0.3rem", justifyContent: justify,
          width: "100%", background: "none", border: "none", cursor: "pointer",
          font: "inherit", color: "inherit", padding: "0.65rem 1rem",
        }}
      >
        {label}
        <span aria-hidden="true" style={{ fontSize: "0.65rem", opacity: active ? 1 : 0.35 }}>
          {active ? (sortDir === "asc" ? "▲" : "▼") : "⇅"}
        </span>
      </button>
    </th>
  );
}
